import { useCallback } from 'react';
import { useAuth } from './useAuth';
import { APP_ROLES_NAMES } from 'constants/app-roles';

export const useRole = () => {
    const { role } = useAuth();
    const isAdminCheck = useCallback(() => {
        return role === APP_ROLES_NAMES.ADMINISTRATOR;
    }, [role]);

    const isAdmin = isAdminCheck();

    return { role, isAdmin };
};
